import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/20/solid";

import aboutPic1 from "../../assets/aboutImages/1.jpg";
import aboutPic2 from "../../assets/aboutImages/2.jpg";
import aboutPic3 from "../../assets/aboutImages/3.jpg";
import aboutPic4 from "../../assets/aboutImages/4.jpg";
import aboutPic5 from "../../assets/aboutImages/5.jpg";
import aboutPic6 from "../../assets/aboutImages/6.jpg";
import aboutPic7 from "../../assets/aboutImages/7.jpg";
import aboutPic8 from "../../assets/aboutImages/8.jpg";
import aboutPic9 from "../../assets/aboutImages/9.jpg";

const aboutPics = [
  aboutPic1,
  aboutPic2,
  aboutPic3,
  aboutPic4,
  aboutPic5,
  aboutPic6,
  aboutPic7,
  aboutPic8,
  aboutPic9,
];

const settings = {
  dots: true,
  infinite: true,
  draggable: true,
  slidesToScroll: 1,
  slidesToShow: 3,
  arrows: true,
  autoplay: true,
  speed: 3000,
  autoplaySpeed: 4000,
  pauseOnHover: true,
  swipe: false,
  touchMove: true,
  cssEase: "linear",
  variableWidth: false, // for mobile friendly handling
  centerMode: false, // avoid centering behavior
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        initialSlide: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
};

export default function SeeUsInAction() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);

  const openModal = (img) => {
    setModalImage(img);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setModalImage(null);
  };

  return (
    <>
      <div className="bg-white py-6 sm:py-12">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="mx-auto max-w-2xl lg:mx-0">
            <h2 className="text-3xl font-semibold tracking-tight text-ttNavy-500 sm:text-3xl">
              See us in action
            </h2>
          </div>
          <div className="w-full slider-container mt-4 text-ttOrange-600">
            <Slider {...settings}>
              {aboutPics.map((aboutPic, index) => (
                <div
                  key={index}
                  className="px-4 py-0"
                  style={{ width: "auto" }}
                >
                  <img
                    src={aboutPic}
                    alt={`Picture ${index}`}
                    className="h-32 w-auto object-contain cursor-pointer"
                    style={{ margin: "0 auto" }}
                    onClick={() => openModal(aboutPic)}
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      {/* Modal for image preview */}
      {modalOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
          onClick={closeModal}
        >
          {/* 
      Add a border and a little shadow to the modal itself.
      We stopPropagation on clicks inside so clicking the border or image
      won't close the modal accidentally.
    */}
          <div
            className="relative bg-white rounded-lg border-4 border-white shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src={modalImage}
              alt="Modal Preview"
              className="max-h-[80vh] max-w-[90vw] object-contain block"
            />

            {/* X button in the top‐right */}
            <button
              className="absolute top-2 right-2 bg-white rounded-full p-1 hover:bg-gray-100"
              onClick={closeModal}
            >
              <XMarkIcon className="h-6 w-6 text-gray-700" aria-hidden="true" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}
